import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableNewPartnerAgreement = Loadable({
  loader: function loader() {
    return import('../NewPartnerAgreement.jsx');
  },
  loading: ComponentLoading
});
export default LoadableNewPartnerAgreement;